import React from "react";
import { Link } from "react-router-dom";

/**
 * Official Hustlers KSA logo.
 * variant: "full" (mark + wordmark) | "mark" (square H icon)
 */
export default function Logo({ variant = "full", className = "", to = "/", asLink = true, testId = "brand-logo" }) {
  const src = variant === "mark" ? "/logo-mark.png" : "/logo.png";
  const img = (
    <img
      src={src}
      alt="Hustlers KSA"
      data-testid={testId}
      className={className || (variant === "mark" ? "h-9 w-auto" : "h-9 w-auto")}
      draggable={false}
    />
  );
  if (!asLink) return img;
  return (
    <Link to={to} className="inline-flex items-center shrink-0" aria-label="Hustlers KSA">
      {img}
    </Link>
  );
}
